export const timespanToMinutes = (ts: string): number => {
  const parts = ts.split(':').map(Number);
  return parts.length >= 2 ? parts[0] * 60 + parts[1] : Number(ts) || 60;
};

export const minutesToTimespan = (minutes: number): string => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:00`;
};
